import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-monthly-sale-overall',
  templateUrl: './monthly-sale-overall.component.html',
  styleUrls: ['./monthly-sale-overall.component.scss']
})
export class MonthlySaleOverallComponent implements OnInit {


  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_list_for_last_12_months: any = [];
  selected_month: any = null;
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  total_sale_details: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;
  selected_month_for_report: any = null;

  constructor(private httpService: HttpService,  private global: GlobalService  ) {
    let today = new Date();
    this.title = this.global._active_display_name;
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
  }



  getClicked() {
    let data_dict = {
      'month': this.selected_month_for_report
    }
    console.log(data_dict);
      this.httpService.monthlySaleOverAllReport(data_dict).subscribe((data) => {
        console.log(data)
        const linkSource = 'data:application/xlsx;base64,' + data['excel'];
        const downloadLink = document.createElement('a');
        const fileName = 'Sale Details Overall.xlsx';

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      });
  }


  ngOnInit() {
  }

}
